export default {
    BASE_URL: '/admin/crm/member',
    api: [
      {
        name: 'list',
        desc: '会员列表',
        method: 'POST',
        path: '/list'
      },
      {
        name: 'export',
        desc: '会员列表导出',
        method: 'POST',
        path: '/list/export'
      },
      {
        name: 'detail',
        desc: '获取会员变更详情',
        method: 'GET',
        path: '/detail'
      },
      {
        name: 'history',
        desc: '获取会员变更记录',
        method: 'GET',
        path: '/history'
      },
      {
        name: 'update',
        desc: '会员变更',
        method: 'POST',
        path: '/update'
      },
      {
        name: 'chapter',
        desc: '所属分会下拉框',
        method: 'GET',
        path: '/chapterAndOffice'
      }
    ]
  }


// WEBPACK FOOTER //
// ./src/api/member/list.js